import jQuery from 'jquery';

export default function initHeaderOffset() {
  let header = jQuery('.header');
  let submenu = jQuery('.sub-menu__wrapp');

  function adjustHeightOffset() {
    const headerHeight = header.outerHeight();
    submenu.css('top', headerHeight * 0.82);
  }

  adjustHeightOffset();

  jQuery(window).on('resize', adjustHeightOffset);
}
